import React from 'react';
import infoCircle from './assets/info-circle.svg';

export const InfoBanner: React.FC = () => {
  return (
    <div className='info-banner'>
      <img src={infoCircle} alt='' className='info-icon' />
      <div className='info-text'>
        Päivitämme ohjelmatietoja sitä mukaa kuin ne virallisesti julkaistaan. Tiedot
        suomalaisosallistujista tulevat yleensä kilpailupäivän aamuun mennessä. Katso päivän koko
        aikataulu Kaikki-välilehdeltä.
      </div>
    </div>
  );
};
